export const STARTED = 'STARTED';
export const COMPLETED = 'COMPLETED';
export const OVERDUE = 'OVERDUE';

export enum TASK_STATE {
  STARTED,
  COMPLETED,
  OVERDUE,
}
